import React from "react";
import { Routes, Route } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import Home from "../screens/Home";
import Menu from "../screens/items/Index";
import WebLogin from "../screens/WebLogin";
import PageNotFound from "../screens/PageNotFound";
import Checkout from "../screens/Checkout";
import OrderStatus from "../screens/OrderStatus";
import PaymentAck from "../screens/PaymentAck";
import Cart from "../screens/cart/Index";
import Customer from "../screens/customer/index";
import StoreClose from "../screens/error/StoreClose";
import Rescan from "../screens/error/Rescan";
import PaymentFailure from "../screens/error/PaymentFailure";
import Css from "../components/Css";
import MultipleStores from "../screens/MultipleStores";
import LoginPopup from "../screens/login/LoginPopup";
import TechnicalError from "../screens/error/TechnicalError";
import PrivacyPolicy from "../screens/PrivacyPolicy";
import TermsCondition from "../screens/TermsCondition";
import ShippingPolicy from "../screens/ShippingPolicy";
import RefundAndCancellation from "../screens/RefundAndCancellation";
import Contactus from "../screens/Contactus";
import Aboutus from "../screens/Aboutus";
import MenuItem from "../screens/MenuItemsOnly/Menu";
import RegistrationForm from "../screens/UserForm";
import AaharUserForm from "../screens/AaharUserForm";
import Test from "../screens/Test";
import Location from "../screens/Location";
import Feedback from "../screens/Feedback";
import ActiveOrderTray from "../components/ActiveOrderTray";
import DiningFooter from "../components/DiningFooter";


export default function Routeindex() {
  return (
    <>
      <Routes classname="bg-bkg text-content ">
        <Route exact path="/login/:store_id/:location_id?" element={<WebLogin />} />
        <Route exact path="/page-404" element={<PageNotFound />} />
        <Route exact path="/location" element={<Location />} />
        <Route exact path="/store-close" element={<StoreClose />} />
        <Route exact path="/rescan" element={<Rescan />} />
        <Route exact path="/tst" element={<Test />} />
        <Route exact path="/error" element={<StoreClose />} />
        <Route exact path="/payment-fail" element={<PaymentFailure />} />
        <Route exact path="/technical-error" element={<TechnicalError />} />

        {/* Public QR feedback page — keyed on store_id (auth flow to be added later) */}
        <Route path="/feedback/:store_id" element={<Feedback />} />
        <Route path="/f/:store_id" element={<Feedback />} />
        <Route
          exact
          path="/login/:store_id/:location_id/:page"
          element={<WebLogin />}
        />

        {/* Protected routes */}
        <Route element={<PrivateRoute />}>
          <Route path="/" element={<Home />} />
          <Route exact path="/payment-fail" element={<PaymentFailure />} />
          <Route exact path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/registration-form" element={<RegistrationForm />} />
          <Route path="/aahar-registration-form" element={<AaharUserForm />} />
          <Route exact path="/terms-condition" element={<TermsCondition />} />
          <Route exact path="/shipping-policy" element={<ShippingPolicy />} />
          <Route exact path="/aboutus" element={<Aboutus />} />
          <Route exact path="/about-us" element={<Aboutus />} />
          <Route
            exact
            path="/refund-policy"
            element={<RefundAndCancellation />}
          />
          <Route exact path="/contactus" element={<Contactus/>}/>
          <Route exact path="/contact-us" element={<Contactus/>}/>
          <Route path="/LoginPopup" element={<LoginPopup />} />
          <Route path="/stores" element={<MultipleStores />} />
          <Route path="/menu" element={<Menu />} />
          <Route path="/menu-items" element={<MenuItem/>} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/customer" element={<Customer />}/>
          <Route path="/order-status" element={<OrderStatus />} />
          <Route path="/payment-ack" element={<PaymentAck />} />
          <Route path="/css" element={<Css />} />
        </Route>
      </Routes>
      <ActiveOrderTray />
      <DiningFooter />
    </>
  );
}
